// Mock data for T4TECH landing page replica
// All data is mocked on the frontend for now.

export const PHONE = "0800 007 4010";
export const PHONE_TEL = "08000074010";
export const EMAIL = "support@t4tech.services";

export const navLinks = [
  { label: "Services", href: "#services" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Guides", href: "#guides" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const heroTags = ["Free", "Independent", "Impartial", "7 Days a Week"];

export const marqueeFeatures = [
  "Free Advice",
  "Independent",
  "Impartial",
  "7 Days a Week",
  "UK Based Advisors",
  "No Upselling",
  "Real Humans",
];

export const networks = [
  "O2",
  "EE",
  "Vodafone",
  "Three",
  "Sky Mobile",
  "giffgaff",
  "Tesco Mobile",
  "Lebara",
];

export const services = [
  {
    icon: "Nfc",
    title: "SIM Card Issues",
    desc: "SIM not working? Card not recognised? We'll walk you through SIM activation, replacement requests and troubleshooting step by step.",
    image:
      "https://images.unsplash.com/photo-1562774555-079298a31cbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxzaW0lMjBjYXJkfGVufDB8fHx8MTc4NTg3MDEyNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: "SignalHigh",
    title: "Network & Signal Problems",
    desc: "No signal, slow data or dropped calls? Our team can diagnose network outages and signal issues and advise on the best next steps.",
  },
  {
    icon: "Receipt",
    title: "Billing & Account Queries",
    desc: "Unexpected charges, billing errors or account access problems? We'll help you understand your bills and guide you through disputes.",
  },
  {
    icon: "TrendingUp",
    title: "Upgrades & New Plans",
    desc: "Looking for a better deal? We provide impartial advice on the best mobile and SIM-only plans for your needs and budget.",
  },
  {
    icon: "RefreshCw",
    title: "SIM Swaps & eSIM Setup",
    desc: "Need a replacement SIM, moving to an eSIM, or swapping your SIM into a new phone? We'll guide you through the whole process step by step.",
    image:
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=1200&auto=format&fit=crop",
  },
  {
    icon: "ArrowLeftRight",
    title: "Number Porting & Transfers",
    desc: "Want to keep your number when switching providers? We'll guide you through the porting process and make switching hassle-free.",
  },
  {
    icon: "SlidersHorizontal",
    title: "Device Setup & Configuration",
    desc: "New phone or device not set up correctly? We help with APN settings, data configuration, voicemail setup and more.",
  },
  {
    icon: "ShieldAlert",
    title: "Lost, Stolen & Blocked Phones",
    desc: "Phone lost or stolen? We'll advise you on what steps to take, including how to bar your device and protect your account.",
  },
];

export const howItWorks = [
  {
    step: "01",
    title: "Call Our Free Number",
    desc: "Dial 0800 007 4010 — it's completely free from any UK landline or mobile. No automated menus, no waiting mazes.",
  },
  {
    step: "02",
    title: "Speak to an Expert",
    desc: "A friendly, knowledgeable advisor will listen to your issue and ask a few simple questions to understand your situation.",
  },
  {
    step: "03",
    title: "Problem Solved",
    desc: "We'll walk you through the solution step by step — most issues are resolved in a single call, at no cost to you.",
  },
];

export const esimSteps = [
  {
    step: "01",
    title: "Check Your Phone Supports eSIM",
    desc: "Most recent iPhones (XS and later) and modern Android phones support eSIM. Not sure? We'll help you confirm yours in seconds.",
  },
  {
    step: "02",
    title: "Request Your eSIM",
    desc: "Ask your network to convert your SIM to an eSIM. They'll send you a QR code or activation details — we'll tell you exactly what to ask for.",
  },
  {
    step: "03",
    title: "Scan the QR Code",
    desc: "On your phone, go to Settings → Mobile/Cellular → Add eSIM, then scan the QR code your network provided. Stay on Wi-Fi throughout.",
  },
  {
    step: "04",
    title: "Activate & Set as Default",
    desc: "Choose your eSIM for calls, texts and data, then restart your phone. If anything looks off, call us and we'll walk you through it.",
  },
];

export const commonIssues = [
  { title: "SIM Not Recognised", desc: "Phone showing no SIM, SIM card error, or SIM not reading." },
  { title: "Can't Make or Receive Calls", desc: "Calls failing, going straight to voicemail or network errors." },
  { title: "Mobile Data Not Working", desc: "No mobile data connection, very slow speeds or 4G/5G problems." },
  { title: "Unexpected Bill Charges", desc: "Charges you don't recognise, premium rate calls or billing errors." },
  { title: "Account Locked or Suspended", desc: "Account access problems, payment issues or service suspension." },
  { title: "Switching Network Provider", desc: "Want to switch networks but don't know how to keep your number." },
  { title: "Roaming Problems Abroad", desc: "Phone not working overseas, high roaming charges, SIM issues abroad." },
  { title: "PIN & PUK Code Locked", desc: "SIM locked, wrong PIN entered, or you need your PUK code to unlock it." },
];

export const testimonials = [
  {
    quote:
      "My SIM stopped working and I had no idea what to do. Called and the advisor sorted everything within 20 minutes — and it didn't cost me a penny. Brilliant service!",
    name: "Sarah Thompson",
    meta: "Manchester · 14 March 2025",
  },
  {
    quote:
      "Had a billing dispute I couldn't resolve myself. The team were patient, clear and genuinely helpful. Completely free advice — would definitely recommend.",
    name: "James Roberts",
    meta: "Birmingham · 2 February 2025",
  },
  {
    quote:
      "Helped me switch networks without losing my number. The advisor explained every step clearly and never once tried to charge or sell me anything. 5 stars!",
    name: "Priya Malhotra",
    meta: "London · 27 January 2025",
  },
];

export const faqs = [
  {
    q: "Are you affiliated with O2, EE, Vodafone or any network?",
    a: "No. T4TECH is a fully independent, third-party support service. We are not affiliated with, endorsed by, or connected to any mobile network, broadband provider, or device manufacturer.",
  },
  {
    q: "How much does your service cost?",
    a: "Nothing at all. Every call and every piece of advice we give is completely free. There are no hidden fees, subscriptions or charges — ever.",
  },
  {
    q: "Is calling 0800 007 4010 really free?",
    a: "Yes. 0800 numbers are free to call from any UK landline or mobile. You won't be charged a penny for reaching us.",
  },
  {
    q: "What networks can you help with?",
    a: "We provide independent advice for customers of all major UK networks including O2, EE, Vodafone, Three, Sky Mobile, giffgaff, Tesco Mobile, Lebara and more.",
  },
  {
    q: "When are your advisors available?",
    a: "Our friendly UK-based advisors are available 7 days a week to help with your mobile and SIM queries.",
  },
  {
    q: "Can you make changes to my account directly?",
    a: "As an independent service we cannot access or change your network account directly. Instead, we guide you step by step so you can resolve issues with confidence.",
  },
];

export const whyPoints = [
  {
    icon: "BadgePoundSterling",
    title: "Completely Free",
    desc: "Every call and every piece of advice is free. No hidden fees, ever.",
  },
  {
    icon: "Scale",
    title: "Independent & Impartial",
    desc: "We're not tied to any network, so our advice is genuinely in your interest.",
  },
  {
    icon: "Ban",
    title: "No Upselling",
    desc: "We won't try to sell you anything. We're here to help, not to pitch.",
  },
  {
    icon: "Users",
    title: "UK Based Advisors",
    desc: "Real, friendly UK experts — available 7 days a week.",
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG5ldHdvcmslMjBjb25uZWN0aW9ufGVufDB8fHx8MTc4NTg3MDEzMnww&ixlib=rb-4.1.0&q=85";


// Help Guides — searchable step-by-step fixes (mocked)
export const guideCategories = ["All", "SIM", "eSIM", "Network", "Billing", "Porting"];

export const guides = [
  {
    id: "sim-not-recognised",
    category: "SIM",
    icon: "Nfc",
    title: "Fix a SIM That's Not Recognised",
    summary: "Phone showing 'No SIM' or 'SIM not detected'? Work through these checks to get it reading again.",
    time: "3 min",
    keywords: ["no sim", "not detected", "sim card error", "not reading"],
    steps: [
      "Power your phone off completely, wait 30 seconds, then switch it back on.",
      "Remove the SIM tray, check the SIM isn't damaged or dirty, and gently wipe the gold contacts with a dry cloth.",
      "Re-seat the SIM firmly in the tray, making sure it sits flat, and reinsert the tray fully.",
      "Toggle Airplane Mode on for 10 seconds, then off again to force a network re-scan.",
      "If it's still not recognised, try the SIM in another phone to check whether the issue is the SIM or the handset.",
    ],
  },
  {
    id: "activate-new-sim",
    category: "SIM",
    icon: "CreditCard",
    title: "Activate a Brand-New SIM Card",
    summary: "Just received a replacement or new SIM? Here's how to get it live on your account.",
    time: "5 min",
    keywords: ["activate", "new sim", "replacement sim", "go live"],
    steps: [
      "Insert the new SIM into your phone while it's switched off.",
      "Power the phone on and connect to Wi-Fi so any updates can download.",
      "Follow your network's activation link or dial their activation number to register the SIM to your account.",
      "Wait up to 24 hours for the new SIM to fully activate — most go live within a couple of hours.",
      "Send a test text and make a short call to confirm calls, texts and data are all working.",
    ],
  },
  {
    id: "esim-iphone",
    category: "eSIM",
    icon: "Smartphone",
    title: "Set Up an eSIM on iPhone",
    summary: "Move to a digital eSIM on your iPhone in a few taps using a QR code from your network.",
    time: "6 min",
    keywords: ["esim", "iphone", "qr code", "digital sim", "apple"],
    steps: [
      "Confirm your iPhone supports eSIM (iPhone XS and later) and is connected to Wi-Fi.",
      "Ask your network to convert your plan to an eSIM — they'll email or show you a QR code.",
      "On your iPhone open Settings → Mobile Service (or Cellular) → Add eSIM.",
      "Choose 'Use QR Code' and scan the code your network provided.",
      "Label the plan, choose it as your default line for calls and data, then restart the phone.",
    ],
  },
  {
    id: "esim-android",
    category: "eSIM",
    icon: "Smartphone",
    title: "Set Up an eSIM on Android",
    summary: "Activate an eSIM on most modern Android phones such as Pixel, Samsung and more.",
    time: "6 min",
    keywords: ["esim", "android", "samsung", "pixel", "download sim"],
    steps: [
      "Check your Android phone supports eSIM (Settings → Connections → SIM manager should show 'Add eSIM').",
      "Request an eSIM QR code from your network provider.",
      "Go to Settings → Connections (or Network & Internet) → SIM manager → Add eSIM.",
      "Tap 'Scan QR code from carrier' and point your camera at the code.",
      "Set the eSIM as your preferred line for mobile data and restart your phone.",
    ],
  },
  {
    id: "no-mobile-data",
    category: "Network",
    icon: "SignalHigh",
    title: "Fix Mobile Data That Won't Connect",
    summary: "Data not working even with signal? These steps restore your connection.",
    time: "4 min",
    keywords: ["mobile data", "4g", "5g", "no internet", "apn"],
    steps: [
      "Check Mobile Data is switched on and Airplane Mode is off in your quick settings.",
      "Confirm you have signal bars and aren't in a known outage area.",
      "Toggle Airplane Mode on and off to reconnect to the network.",
      "Check your APN (Access Point Name) settings match your network's recommended values.",
      "Restart your phone — if data still fails, call us free and we'll check your account setup.",
    ],
  },
  {
    id: "puk-unlock",
    category: "SIM",
    icon: "KeyRound",
    title: "Unlock a Blocked SIM with a PUK Code",
    summary: "Entered the wrong PIN too many times? Use your PUK to safely unlock the SIM.",
    time: "3 min",
    keywords: ["puk", "pin locked", "blocked sim", "unlock"],
    steps: [
      "Find your 8-digit PUK code — it's printed on the original SIM pack or available from your network.",
      "When prompted, enter the PUK code exactly as shown.",
      "Set a new SIM PIN when asked and confirm it.",
      "Important: do not guess the PUK — 10 wrong attempts will permanently block the SIM.",
      "If you can't find your PUK, call us free and we'll guide you through retrieving it.",
    ],
  },
  {
    id: "number-porting",
    category: "Porting",
    icon: "ArrowLeftRight",
    title: "Keep Your Number When Switching Networks",
    summary: "Move to a new provider without losing your mobile number, hassle-free.",
    time: "5 min",
    keywords: ["porting", "pac code", "switch network", "keep number", "transfer"],
    steps: [
      "Text 'PAC' to 65075 from your current phone to receive your free PAC code.",
      "Note the PAC code and the date your current contract ends (sent in the same message).",
      "Give the PAC code to your new network when you join — usually during sign-up.",
      "Your number transfers within one working day; you'll get a text confirming the switch time.",
      "Keep your old SIM in until the transfer completes, then switch to the new one.",
    ],
  },
  {
    id: "unexpected-charges",
    category: "Billing",
    icon: "Receipt",
    title: "Understand Unexpected Bill Charges",
    summary: "Spotted a charge you don't recognise? Here's how to investigate and dispute it.",
    time: "4 min",
    keywords: ["billing", "charges", "premium rate", "dispute", "refund"],
    steps: [
      "Open your latest itemised bill in your network's app or online account.",
      "Identify the unexpected item — common causes are premium-rate numbers, roaming or subscriptions.",
      "Check the date and number against your call and text history to confirm.",
      "Bar premium-rate and subscription services if you didn't sign up for them.",
      "Raise a dispute with your provider — call us free first and we'll help you prepare your case.",
    ],
  },
];
